import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
} from '@frontend/components';

import PaymentTermsForm from './PaymentTermsForm';
import { paymentTermsDrawer } from './data/actions';
import { getIsPaymentTermsDrawerOpen } from './data/reducer';

const PaymentTermsDrawer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsPaymentTermsDrawerOpen);
  const close = useCallback(() => {
    dispatch(paymentTermsDrawer.close());
  }, [dispatch]);

  return (
    <Drawer onClose={close} isOpen={isOpen} size="sm">
      <DrawerContent>
        <DrawerHeader>
          Create Payment Terms
          <DrawerCloseButton />
        </DrawerHeader>
        <PaymentTermsForm />
      </DrawerContent>
    </Drawer>
  );
};

export default PaymentTermsDrawer;
